import { BaseTag }   from "mixs/base/base_mixin";
import watch from "redux-watch";
import isEqual from 'is-equal';
import moment from 'moment';
import { Global, LineCalendarCell, LineSelectedCell } from './planner/model';
import { PlannerController } from './planner_controller';
import { Planner } from './planner_base';
import {
  PLANNER_SCROLL_SET_GETTERS
} from 'apps/events';
import { Lines } from './planner/lines';
// １ページにPlannerをmixinしたriotTagが一つあり、
// 共通のUIを担う
// 各パーツはPlannerBaseを継承し、
// 共通のstore（orders_planner）を扱えるようにする。
//
// PlannerはPlannerControllerを一つインスタンス化し保持する
// PlannerControllerは各パーツからのイベントをリッスンし、
// 適切にstoreを変更する。
//
// PlannerControllerが変更したstoreに対し、
// 各タグが反応し表示を変えるようにする。

class PlannerTag extends Planner {
  controller: PlannerController;
  init(){
    super.init();
    this.controller = new PlannerController(this);
    this.updateDate();
    this.listenMount([this.onMountPlanner]);
  }
  updateDate(){
    let plannerData   = Global.getPlannerData();
    let startMoment   = moment(plannerData.start);
    let lastMoment    = moment(plannerData.last);
    let lastStr       = lastMoment.format('YYYY-MM-DD');
    let currentMoment = moment(plannerData.start);
    let cells = [];
    let index = 0;
    while(currentMoment.format('YYYY-MM-DD') != lastStr){
      cells.push(new LineCalendarCell(currentMoment, index));
      currentMoment.add(1, 'days');
      index ++;
    }
    let newVal = { cells: cells };
    this.dispatchNewValue({ orders_planner: newVal });
  }
  onMountPlanner(){
  }
  setupForScroll(lines:Lines){
    let detail = {
      getContainerWidth: () => {
        if(!lines){ return 0; }
        return lines.getContainerWidth(); },
      getContentWidth: () => {
        if(!lines){ return 0; }
        return lines.getContentWidth();
      }
    }
    let customEvent = new CustomEvent(PLANNER_SCROLL_SET_GETTERS, {detail: detail});
    document.dispatchEvent(customEvent);
  }
}
export class PlannerOne extends PlannerTag {
  onMountPlanner(){
    super.onMountPlanner();
    let lines:Lines = this.tags['orders-planner-lines'] as any;
    this.setupForScroll(lines);
  }
}
export class PlannerMultiple extends PlannerTag {
  onMountPlanner(){
    super.onMountPlanner();
    let tag = this.tags['orders-planner-lines']
    if(tag == null){ return; }
    if(Array.isArray(tag)){
      tag = tag[0];
    }
    let lines:Lines = tag as any;
    this.setupForScroll(lines);
  }
  orders(){
    return this.opts.orders;
  }
  splitedOrders(){
    let orderLength = this.opts.orders.length;
    let ary = []
    let length = 10;
    for(let i=0; i<Math.ceil(orderLength / length); i++){
      ary[i] = this.opts.orders.splice(0, length);
    }
    return ary;
  }
  onUpdatedOrders(index){
    let ordersTag = this.tags['orders-planner-orders'][index + 1];
    if(ordersTag == null){return;}
    ordersTag.setOrdersAndUpdate();
  }
  isSpecificPhases(){
    let phases = Global.getData('planner').phases;
    if(phases == null){return false;}
    if(phases.length <= 0){ return false;}
    return true;
  }
}
riot.mixin('orders.planner', PlannerTag as riot.TagMixin)
riot.mixin('orders.planner.one', PlannerOne as riot.TagMixin)
riot.mixin('orders.planner.multiple', PlannerMultiple as riot.TagMixin)
